import { Component, Input } from '@angular/core';
import {euCompLeagueLinks} from "../../settings";
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    TranslateModule,],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
  @Input() hideTitle: boolean = false;
  protected readonly euCompLeagueLinks = euCompLeagueLinks;
}
